import { http, HttpResponse } from 'msw';
import { PlessService } from '../../app/shared/pless-service.model';
import { ResponseUtils } from './response-utils';

export const kymw10Handlers = [
  // ダッシュボード関連メッセージ情報取得 /kymw10/getDashboardMessage
  http.post(PlessService.SERVICE.getDashboardMessage.url, ({ request }) => {
    const req = request.json();
    console.log(PlessService.SERVICE.getDashboardMessage.url, req);
    return HttpResponse.json(getDashboardMessageResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // ダッシュボードロック情報取得 /kymw10/getDashboardLockInfo
  http.post(PlessService.SERVICE.getDashboardLockInfo.url, ({ request }) => {
    const req = request.json();
    console.log(PlessService.SERVICE.getDashboardLockInfo.url, req);
    return HttpResponse.json(getDashboardLockInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // ユーザ取引先コード一覧取得 /kymw10/getUserSupplierCodeList
  http.post(PlessService.SERVICE.getUserSupplierCodeList.url, ({ request }) => {
    const req = request.json();
    console.log(PlessService.SERVICE.getUserSupplierCodeList.url, req);
    return HttpResponse.json(getUserSupplierCodeListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 関連会社ID更新 /kymw10/updateAssociatedCompanyId
  http.post(PlessService.SERVICE.updateAssociatedCompanyId.url, ({ request }) => {
    const req = request.json();
    console.log(PlessService.SERVICE.updateAssociatedCompanyId.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

];

const getDashboardMessageResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      ProcessControlList: [
        {
          PCMessage: '2024/11/10 1月3回 媒体:ハピデリのサイクル情報が2024/11/25に確定予定です。期限までに設定を完了させてください。',
          PCFormId: ''
        },
        {
          PCMessage: '2024/11/09 3月5回 媒体:ぐるめぐりの企画回が2024/11/24に確定予定です。期限までに設定を完了させてください。',
          PCFormId: ''
        },
        {
          PCMessage: '2024/11/08 8月1回 媒体:きらきらベビーの初校フェーズが2024/11/27に確定予定です。期限までに設定を完了させてください。',
          PCFormId: ''
        },
        {
          PCMessage: '2024/11/07 10月2回 媒体:らくらくコープデリの念校フェーズが2024/12/02に確定予定です。期限までに設定を完了させてください。',
          PCFormId: ''
        },
        {
          PCMessage: '2024/11/06 12月1回 媒体:ライフスタイルの企画が2024/12/05に確定予定です。期限までに設定を完了させてください。',
          PCFormId: ''
        }
      ],
      CautionErrorList: [
        {
          CEMessage: '2024/11/06 全ページチェックエラーが発生しました。エラーファイルの内容を確認してください。',
          CEFormId: ''
        }
      ],
      MessageInfoList: [
        {
          MIMessage: '2024/11/15 10:03 0月0回 商品マスタ画面に遷移します。',
          MIFormId: '1100'
        },
        {
          MIMessage: '2024/11/14 10:03 1月2回 媒体:別チラシ３のサイクル情報が確定しました。内容をご確認ください。',
          MIFormId: ''
        },
        {
          MIMessage: '2024/11/13 10:03 1月4回 媒体:別チラシ４の基版コピーが実行されました。内容をご確認ください。',
          MIFormId: ''
        },
        {
          MIMessage: '2024/11/12 10:03 2月2回 媒体:からだの願いが企画仮確定されました。内容をご確認ください。',
          MIFormId: ''
        },
        {
          MIMessage: '2024/11/11 10:03 3月2回 媒体:IT先着順の初校フェーズが確定しました。内容をご確認ください。',
          MIFormId: ''
        },
        {
          MIMessage: '2024/11/10 10:03 4月2回 媒体:プチハピの念校フェーズが確定しました。内容をご確認ください。',
          MIFormId: ''
        },
        {
          MIMessage: '2024/11/09 10:03 5月2回 媒体:コスメdeきれい（CD）の企画確定フェーズが確定しました。',
          MIFormId: ''
        },
        {
          MIMessage: '2024/11/08 10:03 取引先から商品が提案されました。内容をご確認ください。（2件）',
          MIFormId: '6900'
        },
        {
          MIMessage: '2024/11/07 10:03 商品提案の結果が返却されています。内容をご確認ください。（1件）',
          MIFormId: '6900'
        },
        {
          MIMessage: '2024/11/06 10:03 商品提案の結果が返却されています。内容をご確認ください。（2件）',
          MIFormId: '6900'
        },
        {
          MIMessage: '2024/11/05 10:03 マスタ入力表が登録されました。内容をご確認ください。（1件）',
          MIFormId: '6900'
        },
        {
          MIMessage: '2024/11/04 10:03 10月2回 媒体:ヴィナチュールの選定承認依頼が届いています。内容をご確認ください。',
          MIFormId: '7001'
        },
        {
          MIMessage: '2024/11/03 10:03 11月2回 媒体:デイリー8Pチラシの商品選定依頼が届いています。選定を行ってください。',
          MIFormId: '7003'
        },
        {
          MIMessage: '2024/11/02 10:03 12月2回 媒体:スポットのバイヤー選定依頼が届いています。選定を行ってください。',
          MIFormId: '7006'
        },
        {
          MIMessage: '2024/11/01 10:03 12月3回 媒体:ハピデリの選定依頼結果が届いています。内容をご確認ください。',
          MIFormId: '7000'
        }
      ]
    },
  }
};

const getDashboardLockInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      LockInfoList: [
        {
          OrderCode: '1234567',
          MediumType: 'ハピデリ',
          PCode: '',
          PageNum: 100,
          ProcessName: 'KYMW6800',
          LockStartDate: '2024/11/10 10:03',
          LockerName: 'ページロック実施者',
          LockType: 'PAGE'
        },
        {
          OrderCode: '1234567',
          MediumType: 'ぐるめぐり',
          PCode: '',
          PageNum: null,
          ProcessName: 'KYMW6800',
          LockStartDate: '2024/11/10 10:03',
          LockerName: '企画ロック実施者',
          LockType: 'CATALOG'
        },
        {
          OrderCode: '',
          MediumType: '',
          PCode: 'P1234567',
          PageNum: null,
          ProcessName: 'KYMW6800',
          LockStartDate: '2024/11/10 10:03',
          LockerName: '商品ロック実施者',
          LockType: 'GOODS'
        },
        {
          OrderCode: '1234567',
          MediumType: 'きらきらベビー',
          PCode: 'P1234567',
          PageNum: null,
          ProcessName: 'KYMW6800',
          LockStartDate: '2024/11/10 10:03',
          LockerName: '企画商品ロック実施者',
          LockType: 'PLANGOODS'
        },
        {
          OrderCode: '',
          MediumType: '',
          PCode: '',
          PageNum: null,
          ProcessName: 'KYMW6800',
          LockStartDate: '2024/11/10 10:03',
          LockerName: '画像ロック実施者',
          LockType: 'IMAGE'
        }
      ]
    },
  }
};

const getUserSupplierCodeListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      SupplierInfoList: [
        {
          SupplierCode: "000001",
          SupplierCodeName: "000001:取引先名称１"
        },
        {
          SupplierCode: "000002",
          SupplierCodeName: "000002:取引先名称２"
        },
        {
          SupplierCode: "000003",
          SupplierCodeName: "000003:取引先名称３"
        },
        {
          SupplierCode: "000004",
          SupplierCodeName: "000004:取引先名称４"
        }
     ]
    }
  }
};
